export default ".ccc-jira-dialog .container .content{height:80vh}.ccc-jira-dialog .container .content iframe{border:none}";